import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, getCurrentUserRole } from "../services/auth";

const AdminRoute = ({ element }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  const role = getCurrentUserRole();

  if (role !== "superadmin") {
    return <Navigate to="/" replace />;
  }

  return element;
};

export default AdminRoute;
